export function addLoading(){
    document.body.insertAdjacentHTML('afterbegin',     
        `<div id="loadingBox">
            <div class="loadingElements">
                <p id="loadingText">Loading...</p>
                <div class="loader"></div>
                <a id="loadingError" href="https://discord.gg/9pfWWqaJac" style="color: #000000;">Report an Issue</a>
            </div>
        </div>`
    )
}

export function removeLoading(){
    if(document.getElementById('loadingBox') != undefined){
        document.getElementById('loadingBox').remove()
    }
}

export function setLoadingText(newText){
    if(document.getElementById('loadingText') != undefined){
        document.getElementById('loadingText').innerHTML = newText
    }
}